import { Box, IconButton, Typography } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { Fragment, MouseEvent } from 'react'

import { HerbicideTreatment } from '@/services/get-herbicide-treatments'

import { useStyles } from './styles'

export interface HerbicideTreatmentItemProps {
  herbicideTreatment: HerbicideTreatment
  onOpenMenu: (
    event: MouseEvent<HTMLButtonElement>,
    herbicideTreatment: HerbicideTreatment,
  ) => void
}

export function HerbicideTreatmentItem({
  herbicideTreatment,
  onOpenMenu,
}: HerbicideTreatmentItemProps) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Box
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        marginBottom={'1.5rem'}
      >
        <Box display={'flex'} alignItems={'center'} gridGap={'2rem'}>
          <span className='material-symbols-outlined'>gas_meter</span>
          <Typography variant='subtitle2'>
            {herbicideTreatment.treatment_name}
          </Typography>
        </Box>
        <IconButton
          size='small'
          onClick={(e) => onOpenMenu(e, herbicideTreatment)}
          aria-label='mais opções'
        >
          <MoreVert />
        </IconButton>
      </Box>

      <Box display={'flex'} flex={1} flexDirection={'column'}>
        <div className={classes.herbicides}>
          {herbicideTreatment.herbicides.map((herbicide) => (
            <Fragment key={herbicide.id}>
              <Typography variant='subtitle2'>Herbicida:</Typography>
              <Typography variant='subtitle1'>
                {herbicide.herbicide_name}
              </Typography>
              <Typography variant='subtitle2'>Dose:</Typography>
              <Typography variant='subtitle1'>
                {new Intl.NumberFormat('pt-BR', {
                  minimumFractionDigits: 2,
                }).format(herbicide.herbicide_dose)}
              </Typography>
            </Fragment>
          ))}
        </div>
        <div className={classes.cost}>
          <Typography variant='subtitle2'>Custo:</Typography>
          <Typography variant='subtitle1'>
            {new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(herbicideTreatment.treatment_cost / 100)}{' '}
            /ha
          </Typography>
        </div>
      </Box>
    </div>
  )
}
